export const authActions = {
  WHO_AM_I: 'WHO_AM_I',
  WHO_AM_I_SUCCESS: 'WHO_AM_I_SUCCESS',
  WHO_AM_I_FAIL: 'WHO_AM_I_FAIL',

  LOGOUT: 'LOGOUT',

  whoAmI: () => ({
    type: authActions.WHO_AM_I,
  }),
  whoAmISuccess: data => ({
    type: authActions.WHO_AM_I_SUCCESS,
    payload: { data },
  }),
  whoAmIFail: error => ({
    type: authActions.WHO_AM_I_FAIL,
    payload: { error },
  }),

  logout: () => ({
    type: authActions.LOGOUT,
  }),
};
